export const CONSTANT: any = {
    WEB_DATA: 'webdata',
    equal_operator: "==",
    email: "email",
    DEEPERKS_SESSION_ADMIN: "DEEPERKS_SESSION_ADMIN",
    QR_UPLOAD: "Upload QR",
    RECEIPT_UPLOAD: "Upload Receipt",
}